import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/internal/operators/finalize';
import { map } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { DOCUMENT } from '@angular/common';
import { FirestoreService, AuthService } from 'src/app/services/service.index';

@Component({
  selector: 'app-edituserform',
  templateUrl: './edituserform.component.html',
  styleUrls: ['./edituserform.component.css']
})
export class EdituserformComponent implements OnInit {


  forma = new FormGroup({
    firstname: new FormControl( null, Validators.required),
    lastname: new FormControl(),
    identification: new FormControl(),
    password: new FormControl(null, Validators.required),
    password2: new FormControl(null, Validators.required),
    img: new FormControl(null),
    phone: new FormControl(),
    description: new FormControl(),
    email: new FormControl(null, [Validators.required, Validators.email]),
    status: new FormControl(false),
    role: new FormControl(" ")
  }, {
      validators: this.samePassword('password','password2')
  });

  urlImg:any = "../../../assets/img/images.jpeg";

  imageTemp: string;

  cliente:any = {};

  selectedFile: File = null;
  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;

  activo = false;
  id:any;
  mensajeArchivo = '';
  nombreArchivo = '';

  porcentaje :any ='';
  snapshot:any;
  finalizado = false;
  total = 0;
  img = false;

  nueva:any;

  banDir = false;
  user:any;
  hide = true;

  constructor(@Inject(DOCUMENT) private document, private afs: FirestoreService, private storage: AngularFireStorage, private activatedRoute: ActivatedRoute,  private router: Router, private authService: AuthService) { }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.activatedRoute.params.subscribe(params => {

      //console.log(params.id);

      this.afs.getUser(params.id).subscribe((resp:any) => {

          //console.log(resp);

          this.initValueForm(resp);


      });




    });


  }

  initValueForm(user: any){

    this.urlImg = user.img || this.urlImg;
    this.id = user.id;

    this.forma.patchValue({
      firstname: user.firstname,
      lastname: user.lastname,
      identification: user.identification,
      password: user.password,
      password2: user.password2,
      img: user.img,
      phone: user.phone,
      email: user.email,
      status: user.status,
      role: user.role
    });
  }

  samePassword(field1: string, field2: string){
    return (group: FormGroup) => {

      let pass1 = group.controls[field1].value;
      let pass2 = group.controls[field2].value;

        if(pass1===pass2){
            return null;
        }

        return {
          samePassword: true
        }
    }
}

  updateUser(){

    this.forma.value.img = this.urlImg;
    this.forma.value.id = this.id
    this.forma.value.companyId = this.user.companyId;
    // console.log(this.forma.valid);

    //console.log(this.forma.value);

     if(this.forma.invalid){
       return;
     }


     this.afs.updateUser(this.id, this.forma.value).then((resp) => {

         //this.afs.saveStorage(this.id, this.forma.value);


        Swal.fire('Good job!', 'User ha been updated', 'success');

         this.router.navigate(['/users']);

     }).catch((err) =>{


        Swal.fire('Oops...', 'User has not been updated!!', 'error');

     })


  }

  cambioArchivo(event) {


    if(  event.target.files[0].type.indexOf("image")<0){

       Swal.fire('Oops...', 'Should image!!', 'error');
      return;
    }

    let reader = new FileReader();

    let urlImageTemp = reader.readAsDataURL(event.target.files[0]);

    reader.onloadend = () => {
          this.urlImg = reader.result;
    }

    this.activo = false;
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.mensajeArchivo = `Archivo preparado`; //: ${event.target.files[i].name};
        this.nombreArchivo = event.target.files[i];
        this.document.getElementById('uploader3').value = event.target.files[i].name;
        //console.log(this.nombreArchivo);
        if(this.nombreArchivo){
            this.subirArchivo();
        }
      }
    } else {
      this.mensajeArchivo = 'No hay un archivo seleccionado';
    }
  }

  subirArchivo() {

    this.total = 0;

    //console.log(this.nombreArchivo);
    let n = Date.now();
    const filePath = `armandobucket/${n}`;
     let referencia = this.storage.ref(filePath);
     let tarea = this.storage.upload(`armandobucket/${n}`,this.nombreArchivo);

     //Cambia el porcentaje

     this.activo = true;

     this.porcentaje = tarea.percentageChanges();


       // get notified when the download URL is available
      tarea.snapshotChanges().pipe(
         map(
            x => {  this.total = Math.round((x.bytesTransferred/x.totalBytes) * 100); /*console.log(this.total)*/ }
         ),
         finalize(async () => {

                                 this.downloadURL = await referencia.getDownloadURL().toPromise();

                                 this.urlImg = this.downloadURL;


                                 this.afs.usersShow.img = this.urlImg;

                                // this.db.collection('files').add( { img: this.urlImg })

                                 setTimeout(() => {
                                       this.activo = false;
                                       this.img =true;
                                 },600)

                         })
      )
     .subscribe()
   }
}
